// extracted by mini-css-extract-plugin
export default {"navbar":"II1sqi27UtfGkaLYKB7T"};